import { Component, EventEmitter, Output } from '@angular/core';
import { ISuperTableCalculationFunction } from '@modeso/types__aumico-lib-annualreport-be';

@Component({
    selector: 'calculation-function-selection',
    templateUrl: './calculation-function-selection.component.html',
    styleUrls: ['./calculation-function-selection.component.scss'],
})
export class CalculationFunctionSelection {
    calculation = ISuperTableCalculationFunction;
    selectedOption: ISuperTableCalculationFunction | undefined;

    @Output() selectedCalculationFunction: EventEmitter<ISuperTableCalculationFunction | undefined> = new EventEmitter<
        ISuperTableCalculationFunction | undefined
    >();

    onSelectedCalculationFunctionChange(calc: ISuperTableCalculationFunction) {
        this.selectedOption = calc;
        this.selectedCalculationFunction.emit(calc);
    }
}
